import { JobsFeed } from '../pages/JobsFeed';

export function RootRedirect() {
  return <JobsFeed />;
}
